import { cx } from 'class-variance-authority';
import type { ClassValue } from 'class-variance-authority/types';
import { Skeleton } from '~/components/primitives/skeleton';

export const ActivityCard_Skeleton: React.FC<{
    className?: ClassValue;
    style?: React.CSSProperties;
}> = props => (
    <div
        className={cx(
            'shadow-xs flex flex-col overflow-hidden rounded-3xl bg-white px-3 pt-3 hover:cursor-pointer',
            props.className,
        )}
        style={props.style}
    >
        {/* Image skeleton */}
        <Skeleton className="flex w-full flex-1 rounded-3xl" />

        {/* Content skeleton */}
        <div className="mb-6 mt-4">
            <Skeleton className="mx-3 h-3 w-3/12 rounded-lg" />
            <Skeleton className="mx-3 mt-3 h-2 rounded-lg" />
        </div>
    </div>
);
